module.exports = __webpack_public_path__ + "img/ecmascript6logo.47a9aa4c.png";